import { FieldRequired, FieldValid } from '@cgn/framework-ui-components/v2';
import { useCallback, useState } from 'react';

export default function useRequiredField(initText, onChange) {
  const [text, setText] = useState(initText);
  const [validation, setValidation] = useState(FieldRequired);
  const [touched, setTouched] = useState(false);

  const handleOnChange = useCallback((newValue) => {
    setTouched(true);
    setText(newValue);
    if (!newValue || newValue.length === 0) {
      setValidation(FieldRequired);
    } else {
      setValidation(FieldValid);
    }
    onChange?.(newValue);
  }, [onChange]);

  return {
    state: touched ? validation.state : undefined,
    stateMessage: touched ? validation.stateMessage : undefined,
    onChange: handleOnChange,
    text,
  };
}
